import {
  zLabWorkbookSummaryResponse,
  type LabWorkbookSummaryResponse,
  type MarkLabWorkbookReadyRequest,
  type UpdateLabWorkbookRequest,
  type AssignLabWorkbookRequest,
} from '@resistapp/common/api-types';

import { getAuthHeaders, resistomapApiClient } from '../../../utils/fetch';
import type { LabWorkbookSummary } from './use-lab-workbook';

export async function patchLabWorkbook(
  workbookId: string,
  payload: UpdateLabWorkbookRequest,
): Promise<LabWorkbookSummary> {
  const response = await resistomapApiClient.patch<LabWorkbookSummaryResponse>(`/lab/${workbookId}`, payload, {
    headers: getAuthHeaders('application/json'),
  });
  const parsed = zLabWorkbookSummaryResponse.parse(response.data);
  return parsed as LabWorkbookSummary;
}

export async function markLabWorkbookReady(
  workbookId: string,
  payload: MarkLabWorkbookReadyRequest,
): Promise<LabWorkbookSummary> {
  const response = await resistomapApiClient.post<LabWorkbookSummaryResponse>(`/lab/${workbookId}/ready`, payload, {
    headers: getAuthHeaders('application/json'),
  });
  const parsed = zLabWorkbookSummaryResponse.parse(response.data);
  return parsed as LabWorkbookSummary;
}

export async function assignLabWorkbook(workbookId: string, payload: AssignLabWorkbookRequest): Promise<LabWorkbookSummary> {
  const response = await resistomapApiClient.post<LabWorkbookSummaryResponse>(
    `/lab-workbook/${workbookId}/assignment`,
    payload,
    { headers: getAuthHeaders('application/json') },
  );
  const parsed = zLabWorkbookSummaryResponse.parse(response.data);
  return parsed as LabWorkbookSummary;
}
